import { ElementRef, OnDestroy } from '@angular/core';
import { ResponsiveStateService } from './responsive-state.service';
import { ReplaySubject } from 'rxjs';
var ResponsiveSrcDirective = /** @class */ (function () {
    function ResponsiveSrcDirective(state, elementRef) {
        var _this = this;
        this.state = state;
        this.elementRef = elementRef;
        this.src = new ReplaySubject(1);
        this.finalSrc = this.src
            .switchMap(function (src) { return _this.state.getWidth(_this.elementRef.nativeElement).map(function (w) { return [src, w]; }); })
            .map(function (_a) {
            var src = _a[0], finalWidth = _a[1];
            if (!finalWidth) {
                return src;
            }
            var src_parts = src.split('.');
            var extension = src_parts.pop();
            var basename = src_parts.join('.');
            return basename + "-" + finalWidth + "w." + extension;
        });
        this.srcSub = this.finalSrc.subscribe(function (src) { return _this.elementRef.nativeElement.src = src; });
    }
    Object.defineProperty(ResponsiveSrcDirective.prototype, "_src", {
        set: function (src) {
            this.src.next(src);
        },
        enumerable: true,
        configurable: true
    });
    ResponsiveSrcDirective.prototype.ngOnDestroy = function () {
        this.srcSub.unsubscribe();
    };
    return ResponsiveSrcDirective;
}());
export { ResponsiveSrcDirective };
